const STYLES = {
  yes: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  maybe: "bg-amber-50 text-amber-700 ring-amber-200",
  no: "bg-red-50 text-red-700 ring-red-200",
};

export const ResponseBadge = ({ value }) => (
  <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-bold uppercase tracking-wider ring-1 ${STYLES[value]}`}>{value}</span>
);
